import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { OfferPage } from './pages/OfferPage';
import { PrezentareCompleta } from './pages/PrezentareCompleta';
import { Acasa } from './pages/Acasa';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<OfferPage data-id="element-3" />} data-id="element-2" />
        <Route path="/prezentarecompleta" element={<PrezentareCompleta data-id="element-5" />} data-id="element-4" />
        <Route path="/acasa" element={<Acasa data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}